/** 系统平台管理 **/

import Layout from "@/views/layout/Layout";

const platformManRouter = {
  path: "/platformManSystem",
  component: Layout,
  name: "platformManSystem",
  meta: {
    title: "平台管理",
    icon: "form",
    roles: ["pingtaiguanli"]
  },
  alwaysShow: true,
  children: [

    // 测试dataRoom大屏
    {
      path: "dataRoom",
      name: "大屏管理（管理者）",
      component: () =>
        import("@/views/platformManSystem/dataRoom/index"),
      meta: {
        title: "大屏管理（管理者）",
        // icon: 'lock',
        roles: ["juesequanxian"]
      }
    },
    {
      path: "dataRoomStaff",
      name: "大屏管理（员工）",
      component: () =>
        import("@/views/platformManSystem/dataRoomStaff/index"),
      meta: {
        title: "大屏管理（员工）",
        // icon: 'lock',
        roles: ["juesequanxian"]
      }
    },

    ////////////
    {
      path: "jurisdictionMan",
      name: "角色权限",
      component: () =>
        import("@/views/platformManSystem/jurisdictionMan/index"),
      meta: {
        title: "角色权限",
        // icon: 'lock',
        roles: ["juesequanxian"]
      }
    },

    {
      path: "roleMan",
      component: () => import("@/views/platformManSystem/roleMan/index"),
      name: "权限管理",
      meta: {
        title: "权限管理",
        roles: ["quanxianguanli_web"],
        keepAlive: true
      }
    },

    {
      path: "dataDic",
      name: "数据字典",
      component: () => import("@/views/platformManSystem/dataDic"),
      meta: {
        title: "数据字典",
        // icon: 'lock',
        roles: ["shujuzidian"]
      }
    },

    {
      path: "macMan",
      name: "MAC管理",
      component: () => import("@/views/platformManSystem/macMan"),
      meta: {
        title: "MAC管理",
        // icon: 'lock',
        roles: ["macguanli"]
      }
    },

    {
      path: "projectMan",
      name: "项目配置",
      component: () => import("@/views/platformManSystem/projectMan/index"),
      meta: {
        title: "项目配置",
        // icon: 'lock',
        // roles: ['xiangmupeizhi']
        roles: ["xiangmupeizhi"]
      }
    },

    {
      path: "operateMan",
      name: "运维管理",
      component: () => import("@/views/platformManSystem/operateMan/index"),
      meta: {
        title: "运维管理",
        // icon: 'lock',
        roles: ["yunweiguanli"]
      }
    },

    // {
    //   path: 'bpmnMan',
    //   name: '业务协同',
    // 	component: () => import('@/views/platformManSystem/bpmnMan'),
    //   meta: {
    //     title: '业务协同',
    //     // icon: 'lock',
    //     roles: ['shujuzidian']
    //   }
    // },

    // {
    //   path: 'messageMan',
    //   name: '消息管理',
    // 	component: () => import('@/views/platformManSystem/messageMan'),
    //   meta: {
    //     title: '消息管理',
    //     // icon: 'lock',
    //     roles: ['xiaoxiguanli']
    //   }
    // },
    // {
    //   path: "noticeAnnouncement",
    //   name: "通知公告",
    //   component: () => import("@/views/platformManSystem/noticeAnnouncement"),
    //   meta: {
    //     title: "通知公告",
    //     // icon: 'lock',
    //     roles: ["tongzhigonggao"]
    //   }
    // },
    {
      path: "postNameMan",
      name: "岗位名称维护",
      component: () => import("@/views/platformManSystem/postNameMan/index"),
      meta: {
        title: "岗位名称维护",
        // icon: 'lock',
        roles: ["gangweimingchengweihu"]
      }
    },

    // 模板管理
    // {
    //   path: 'excelMan',
    //   name: 'excel模板管理',
    // 	component: () => import('@/views/dataDic/dataDic'),
    //   meta: {
    //     title: '数据字典2',
    //     // icon: 'lock',
    //     roles: ['admin', 'editor']
    //   }
    // },
    {
      path: "dataDicEdit/:groupText/:groupChar",
      name: "编辑",
      component: () => import("@/views/platformManSystem/dataDicEdit"),
      hidden: true,

      meta: {
        title: "编辑数据字典",
        // icon: 'lock',
        roles: ["shujuzidian"],
        activeMenu: "/platformManSystem/dataDic"
      }
    },

  ]
};

export default platformManRouter;
